import { createSlice } from '@reduxjs/toolkit';

const initialState={
    license:null
}
export const licenseSlice = createSlice({
  name: 'license',
  initialState,
  reducers: {

    setLicense: (state, action) => {
      state.license= action.payload;
    },
    setLogoutLicense: (state,action)=>{
      state.license=null
    }
  },
});

export const {  setLicense,setLogoutLicense } = licenseSlice.actions;

export default licenseSlice.reducer;
